import { render, staticRenderFns } from "./rubik.vue?vue&type=template&id=75fe1a89&scoped=true&"
import script from "./rubik.vue?vue&type=script&lang=js&"
export * from "./rubik.vue?vue&type=script&lang=js&"
import style0 from "./rubik.vue?vue&type=style&index=0&id=75fe1a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fe1a89",
  null
  
)

export default component.exports